import { render } from "./Groupbuies.vue?vue&type=template&id=11cf62d6&scoped=true"
import script from "./Groupbuies.vue?vue&type=script&lang=js"
export * from "./Groupbuies.vue?vue&type=script&lang=js"

import "./Groupbuies.vue?vue&type=style&index=0&id=11cf62d6&lang=scss&scoped=true"

import exportComponent from "/var/www/html/OrderUser/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11cf62d6"]])

export default __exports__